<div class="order-summary">
  <p class="order-summary__title">Order Summary</p>
  <div class="order-summary__items">
    <span>Items</span>
    <span>{{ count }}</span>
  </div>
  <div class="order-summary__total">
    <span>Total</span>
    <span>{{ totalPrice | transformPrice }}</span>
  </div>
</div>
